<template>
    <div class="text-center">
        <v-overlay
            :model-value="isLoading"
            class="align-center justify-center"
            persistent
        >
            <v-progress-circular
                color="primary"
                size="64"
                indeterminate
            />
        </v-overlay>
    </div>
</template>

<script setup>
import { inject, computed } from 'vue'
import INJECTION_KEYS from '@injectionKeys'

/** @type {GlobalState} */
const globalState = inject(INJECTION_KEYS.GLOBALSTATE)

const isLoading = computed(() => globalState.isLoading )
</script>